import { render, staticRenderFns } from "./student-access-activities-table.vue?vue&type=template&id=69b7d4ba&scoped=true"
import script from "./student-access-activities-table.ts?vue&type=script&lang=ts&external"
export * from "./student-access-activities-table.ts?vue&type=script&lang=ts&external"
import style0 from "./student-access-activities-table.scss?vue&type=style&index=0&id=69b7d4ba&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b7d4ba",
  null
  
)

export default component.exports